import axios from 'axios';
import api   from './api';

// Separate axios instance for public endpoints — no auth token, no X-Club-Slug header
const publicApi = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000',
});

// ── Public (no auth required) ─────────────────────────────────────────────────

export const getClubTrialInfo = (clubSlug) =>
  publicApi.get(`/api/public/trial/${clubSlug}/info`);

export const submitTrialApplication = (clubSlug, data) =>
  publicApi.post(`/api/public/trial/${clubSlug}/apply`, data);

export const submitQuickEnquiry = (clubSlug, data) => {
  const slug = (clubSlug || '').toString().trim();
  if (!slug || slug === 'undefined' || slug === 'null') {
    const err = new Error('We could not identify this club. Please contact the club directly.');
    err.isFriendlySlugError = true;
    return Promise.reject(err);
  }
  return publicApi.post(`/api/public/trial/${encodeURIComponent(slug)}/quick-enquiry`, data);
};

export const pingClub = (clubSlug) =>
  publicApi.get(`/api/public/trial/${encodeURIComponent(clubSlug)}/ping`);

export const getInviteInfo = (token) =>
  publicApi.get(`/api/public/trial/invite/${token}`);

export const completeInvite = (token, data) =>
  publicApi.post(`/api/public/trial/invite/${token}/complete`, data);

// ── Admin / Trainer (auth required) ──────────────────────────────────────────

export const getTrialApplications = (params) =>
  api.get('/api/trial/applications', { params });

export const getTrialApplicationById = (id) =>
  api.get(`/api/trial/applications/${id}`);

export const updateTrialStatus = (id, data) =>
  api.patch(`/api/trial/applications/${id}/status`, data);

export const addTrialNote = (id, note) =>
  api.patch(`/api/trial/applications/${id}/notes`, { note });

export const inviteToJoin = (id) =>
  api.post(`/api/trial/applications/${id}/invite-to-join`);

export const deleteTrialApplication = (id) =>
  api.delete(`/api/trial/applications/${id}`);

export const createManualTrial = (data) =>
  api.post('/api/trial/applications', data);

export const convertDirect = (id, data) =>
  api.post(`/api/trial/applications/${id}/convert-direct`, data);
